module.exports = __webpack_public_path__ + "static/media/bg.ecce9144.png";